import { useEffect } from 'react';
import { useUserStore } from 'src/store/user-store';

import { useUserInfo } from '@/features/organization-admins/hooks/query/use-user-info';
import { useAvailableOrganizations } from '@/features/shared/hooks/query/use-available-organizations';
import { determineUserRole } from '@/utils/determine-user-role';

export const useSetInitialOrganization = (isLoggedIn: boolean = true) => {
  const setOrganizationToken = useUserStore(state => state.setOrganizationToken);
  const setSiteToken = useUserStore(state => state.setSiteToken);
  const setUserRole = useUserStore(state => state.setUserRole);
  const setUserId = useUserStore(state => state.setUserId);
  const siteToken = useUserStore(state => state.siteToken);
  const organizationToken = useUserStore(state => state.organizationToken);

  const {
    data: availableOrganizationsData,
    isLoading: isLoadingAvailableOrganizations,
    error: availableOrganizationsError,
  } = useAvailableOrganizations(isLoggedIn);

  const hasAvailableOrganizations =
    availableOrganizationsData && availableOrganizationsData?.length >= 1;

  useEffect(() => {
    if (isLoggedIn && hasAvailableOrganizations && (!organizationToken || !siteToken)) {
      setOrganizationToken(availableOrganizationsData?.[0]?.token);
      setSiteToken(availableOrganizationsData?.[0]?.sites?.[0]?.token);
    }
  }, [availableOrganizationsData, hasAvailableOrganizations, isLoggedIn, siteToken, organizationToken]);

  const { data: userInfoData } = useUserInfo(isLoggedIn);

  useEffect(() => {
    if (userInfoData && isLoggedIn) {
      setUserRole(determineUserRole(userInfoData?.isOwner));
      setUserId(userInfoData?.id?.toString());
    }
  }, [userInfoData, isLoggedIn]);

  return {
    isLoadingAvailableOrganizations,
    availableOrganizationsError,
  };
};
